package com.fireavert.administration.super_admin_tools_page.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class SuperAdminSettingsRequest(
    val userId: Int? = null,
    val percentageOfDevicesOffline: Int = 10,
    val notificationsEnabled: Boolean = false,
)